import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ReactCountdown from 'react-countdown';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import { RefreshIcon } from '../../../../../../../constants/icon-constants';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/countdown/countdown.module.scss';
import Header from '../../../../../../../components/Stake/header';
import DotIcon from '../../../../../../../assets/images/tokens/dot.svg';
import MigrationBg from '../../../../../../../assets/images/migration-icon.svg';
import MigrationDarkBg from '../../../../../../../assets/images/migration-dark-icon.svg';
import Timer from './timer';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';

const WithdrawCountdown = ({ date, setStatus }) => {
  const colors = useGetTheme();
  const dark = useSelector((state) => state.basic.dark);
  const [isFinished, setIsFinished] = useState(new Date().getTime() > date);

  return (
    <>
      <Header icon={DotIcon} title='DOT-Nomination' />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div className={styles.title}>Nominated DOT will show in</div>
        {isFinished ? (
          <div className={styles.title}>Available Now</div>
        ) : (
          <ReactCountdown
            date={date}
            renderer={(props) => <Timer {...props} withSeconds />}
            onComplete={() => {
              setIsFinished(true);
              setStatus(2);
            }}
          />
        )}
        <img className={styles.image} src={dark ? MigrationDarkBg : MigrationBg} alt='' />
        <div>
          <div className={styles.description}>
            <b>IMPORTANT!</b> It takes one era (24 hours) for DOT to nominate to new validators.
            Your nominated DOT will not show up in the app until after that era which can be any
            time up to 24 hours depending on the current era.
          </div>
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => window.location.reload()}
            variant='contained'
            color='secondary'
            className={cn(styles.button, stylesParent.cardFooterControlsButton)}
          >
            Refresh Page
            {RefreshIcon}
          </Button>
        </div>
      </div>
    </>
  );
};

WithdrawCountdown.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default WithdrawCountdown;
